import moment from "moment";
import _ from "lodash";
import { getTranslation } from "helpers/common";

import { ROLE_IDS } from "constants/.";

export const getFormatted = (value, type) => {
  switch (type) {
    case "percent":
      return `${(value || 0).toString().replace(".", ",")} %`;
    case "currency":
      return value
        ? `€ ${Number(value).toLocaleString("nl-NL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`
        : "-";
    case "boolean":
      return value ? getTranslation("YES") : getTranslation("NO");
    case "date":
      return value ? moment(value).format("DD-MM-YYYY") : "-";
    case "absolute":
      return value
        ? Math.abs(value).toLocaleString("nl-NL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : "-";
    case "number":
      return value
        ? Number(value).toLocaleString("nl-NL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : "-";
    default:
      return value == null || value === undefined ? "-" : value;
  }
};

export const limitDecimals = value => {
  const [, afterPoint = ""] = value.toString().split(".");

  return afterPoint.length > 2 ? Number(value).toFixed(2) : value;
};

export const modifyCurrencyField = (data, key, index = "-1") =>
  _.includes(["Aankoop", "Purchase", "Buying"], _.get(data, "PurchaseType"))
    ? _.get(data, _.replace(key, "index", index))
    : _.get(data, _.replace(key, "index", index)) * -1;

export const getRoleId = (roleId, derivativeOrder) => {
  if (derivativeOrder) {
    return ROLE_IDS[roleId] === "Buyer" ? "Seller" : "Supplier";
  }

  return roleId;
};

// Profile name needs to be lowercase
// Exception: if all letters are in uppercase, then the username is displayed in uppercase
export const formatProfileName = profileName => {
  const isAllUppercase = profileName === profileName.toUpperCase();
  const formattedName = (profileName || "")
    .replace(/@.*/, "")
    .replace(/[^a-zA-Z0-9]/g, "");
  return isAllUppercase ? formattedName : formattedName.toLowerCase();
};
